import { render, staticRenderFns } from "./yue.vue?vue&type=template&id=3523a90e&scoped=true&"
import script from "./yue.vue?vue&type=script&lang=js&"
export * from "./yue.vue?vue&type=script&lang=js&"
import style0 from "./yue.vue?vue&type=style&index=0&id=3523a90e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523a90e",
  null
  
)

export default component.exports